import { picoapp } from 'picoapp';
import '../sass/theme.scss';
import { merge } from 'lodash-es';
import AppComponents from './AppComponents';
import { AppTemplates } from './AppTemplates';
import AppState from './AppState';
import common from './features/common';
import icons from './features/icons';
import webfonts from './features/webfonts';

const components = merge(AppComponents, AppTemplates);
const app = picoapp(components, AppState);

app.mount(['data-component', 'data-template', 'data-view']);

window.app = app;
common.init(app);
webfonts.init();
icons.init();
